// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar_sidebar__c7D0R {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 0px;
  margin-bottom: -20px;
  gap: 200px;
  width: 33%;
  min-width: 314px;
  background: #ffffff;
  border-right: 1px solid #e9e9e9;
}
.Sidebar_sidebar__c7D0R .Sidebar_profileImg__kdYov {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 28px;
  width: 100%;
  height: 124px;
}
.Sidebar_sidebar__c7D0R .Sidebar_profileImg__kdYov .Sidebar_profileImgText__rQdrG {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 52px;
  height: 52px;
  background: #1f1f1f;
  border-radius: 100px;
}
.Sidebar_sidebar__c7D0R .Sidebar_profileImg__kdYov .Sidebar_profileImgText__rQdrG .Sidebar_avatarText__V4R2u {
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #ffffff;
  -webkit-user-select: none;
          user-select: none;
}
.Sidebar_sidebar__c7D0R .Sidebar_navList__h6JK3 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  min-width: 282px;
  width: 75%;
}
.Sidebar_sidebar__c7D0R .Sidebar_navList__h6JK3 .Sidebar_item__PxHXo, .Sidebar_sidebar__c7D0R .Sidebar_navList__h6JK3 .Sidebar_itemActive__lKS4v {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 24px;
  gap: 12px;
  width: 100%;
  height: 36px;
  border-radius: 200px;
}
.Sidebar_sidebar__c7D0R .Sidebar_navList__h6JK3 .Sidebar_item__PxHXo .Sidebar_text__7POgZ, .Sidebar_sidebar__c7D0R .Sidebar_navList__h6JK3 .Sidebar_itemActive__lKS4v .Sidebar_text__7POgZ {
  width: 100%;
  height: 28px;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #151515;
  -webkit-user-select: none;
          user-select: none;
}
.Sidebar_sidebar__c7D0R .Sidebar_navList__h6JK3 .Sidebar_item__PxHXo .Sidebar_icon__0uPfZ, .Sidebar_sidebar__c7D0R .Sidebar_navList__h6JK3 .Sidebar_itemActive__lKS4v .Sidebar_icon__0uPfZ {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  width: 20px;
  height: 20px;
}
.Sidebar_sidebar__c7D0R .Sidebar_navList__h6JK3 .Sidebar_item__PxHXo:hover, .Sidebar_sidebar__c7D0R .Sidebar_navList__h6JK3 .Sidebar_itemActive__lKS4v:hover {
  background-color: #151515;
  color: #e9e9e9;
}
.Sidebar_sidebar__c7D0R .Sidebar_navList__h6JK3 .Sidebar_item__PxHXo:hover .Sidebar_text__7POgZ, .Sidebar_sidebar__c7D0R .Sidebar_navList__h6JK3 .Sidebar_itemActive__lKS4v:hover .Sidebar_text__7POgZ {
  color: #e9e9e9;
  font-weight: 600;
}
.Sidebar_sidebar__c7D0R .Sidebar_navList__h6JK3 .Sidebar_itemActive__lKS4v {
  background: #151515;
  color: #e9e9e9;
}
.Sidebar_sidebar__c7D0R .Sidebar_navList__h6JK3 .Sidebar_itemActive__lKS4v .Sidebar_text__7POgZ {
  color: #e9e9e9;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/views/MyProfile/Sidebar/Sidebar.module.scss"],"names":[],"mappings":"AAKA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,UAAA;EACA,UATc;EAUd,gBAAA;EACA,mBAAA;EACA,+BAAA;AAJF;AAKE;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;AAHJ;AAII;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;AAFN;AAGM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;AADR;AAME;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;AAJJ;AAKI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AAHN;AAIM;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;AAFR;AAIM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAFR;AAIM;EACE,yBAAA;EACA,cAAA;AAFR;AAGQ;EACE,cAAA;EACA,gBAAA;AADV;AAKI;EAEE,mBAAA;EACA,cAAA;AAJN;AAKM;EAEE,cAAA;EACA,gBAAA;AAJR","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n$sidebar-width: 33%;\n\n.sidebar {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 48px 0px;\n  margin-bottom: -20px;\n  gap: 200px;\n  width: $sidebar-width;\n  min-width: 314px;\n  background: #ffffff;\n  border-right: 1px solid #e9e9e9;\n  .profileImg {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 28px;\n    width: 100%;\n    height: 124px;\n    .profileImgText {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      width: 52px;\n      height: 52px;\n      background: #1f1f1f;\n      border-radius: 100px;\n      .avatarText {\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 32px;\n        display: flex;\n        align-items: center;\n        text-align: center;\n        color: #ffffff;\n        user-select: none;\n      }\n    }\n  }\n\n  .navList {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 24px;\n    min-width: 282px;\n    width: 75%;\n    .item {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      padding: 0px 24px;\n      gap: 12px;\n      width: 100%;\n      height: 36px;\n      border-radius: 200px;\n      .text {\n        width: 100%;\n        height: 28px;\n        font-weight: 400;\n        font-size: 20px;\n        line-height: 28px;\n        display: flex;\n        align-items: center;\n        text-align: center;\n        color: #151515;\n        user-select: none;\n      }\n      .icon {\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n        padding: 8px;\n        width: 20px;\n        height: 20px;\n      }\n      &:hover {\n        background-color: #151515;\n        color: #e9e9e9;\n        .text {\n          color: #e9e9e9;\n          font-weight: 600;\n        }\n      }\n    }\n    .itemActive {\n      @extend .item;\n      background: #151515;\n      color: #e9e9e9;\n      .text {\n        @extend .text;\n        color: #e9e9e9;\n        font-weight: 600;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `Sidebar_sidebar__c7D0R`,
	"profileImg": `Sidebar_profileImg__kdYov`,
	"profileImgText": `Sidebar_profileImgText__rQdrG`,
	"avatarText": `Sidebar_avatarText__V4R2u`,
	"navList": `Sidebar_navList__h6JK3`,
	"item": `Sidebar_item__PxHXo`,
	"itemActive": `Sidebar_itemActive__lKS4v`,
	"text": `Sidebar_text__7POgZ`,
	"icon": `Sidebar_icon__0uPfZ`
};
export default ___CSS_LOADER_EXPORT___;
